import React, { useContext } from "react";
import { Carousel, Image } from "antd";
import { ItemInfoWrapper } from "../../container/Styles/Wrappers";
import CapacityInfo from "./components/CapacityInfo";
import BedInfo from "./components/BedInfo";
import { AppContext } from "../../context";
import { lng } from "../../library/language";
import Amenities from "./components/Amenities/Amenities";
import Typology from "./components/Typology";

function RoomInfo({ product, store }) {
  const info = useContext(AppContext);
  const language = info.language;

  return (
    <ItemInfoWrapper>
      <Carousel>
        {product.gen_files?.map((im, index) => (
          <Image alt={im.alt} src={im.url} height={400} key={index} />
        ))}
      </Carousel>
      <div className="title">
        <h1 className="item-name">{product.gen_name}</h1>
        {store?.name && (
          <h2 className="item-parent">{lng(store.name, language)}</h2>
        )}
      </div>
      <div style={{ overflow: "scroll" }}>
        <div style={{ padding: 16 }}>
          <div className="ahp-room-indicators">
            {product.lod_room_type && (
              <div className="ahp-room-category-indicators">
                <Typology room_type={product.lod_room_type} t={info.t} />
              </div>
            )}
            <div className="ahp-room-category-indicators">
              <CapacityInfo
                adults={product.lod_capacity_adults}
                children={product.lod_capacity_children}
              />
            </div>
            <div className="ahp-room-category-indicators">
              <BedInfo beds={product.lod_beds} />
            </div>
          </div>
          <div className="ahp-description" style={{ marginTop: 16 }}>
            {product.gen_description[info.language]}
          </div>
          <div className="ahp-description-additional" style={{ marginTop: 16 }}>
            {product.gen_description_additional[info.language]}
          </div>
        </div>
        {product?.lod_amenities?.length > 0 && (
          <Amenities amenities={product.lod_amenities} />
        )}
      </div>
    </ItemInfoWrapper>
  );
}

export default RoomInfo;
